import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button, ButtonProps } from 'components/atoms/button';
import { SingleLineEllipsis } from 'components/styles';

export const SaveUpdateViewButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button
      data-cy="views.new-view.save"
      iconPlacement="right"
      type="primary"
      {...rest}
    >
      {children}
    </Button>
  );
};

export const CancelSaveViewButton = ({ onClick }: ButtonProps) => {
  return (
    <Button data-cy="views.new-view.cancel" onClick={onClick}>
      <FormattedMessage id="cancel" />
    </Button>
  );
};

export const HoverableLinkButton = styled(Button).attrs((props) => ({
  size: props.size || 'small',
  type: 'link',
  hideHoverEffect: true,
  hideHoverBorderRadius: true,
}))`
  max-width: 152px;
  &:hover {
    color: var(--white-100);
    background: var(--primary-color);
  }
  > svg {
    flex-shrink: 0;
  }
  > span {
    width: 100%;
    ${SingleLineEllipsis};
  }
`;

export const TaskFilterButton = styled(HoverableLinkButton)`
  border-color: var(--primary-color);
`;

export const ButtonWrapper = styled.div`
  display: flex;

  ${HoverableLinkButton} {
    border-color: var(--primary-color);
  }
  > ${HoverableLinkButton}:first-child {
    border-right-width: 0px;
  }
`;
